import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { merge, Observable } from 'rxjs';
import { filter, map, scan } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { campaignCompare } from '../../../../../adreno-common/src/lib/utils';
import { IdleService, WebPopService, WorkService } from '../services';
@Component({
  selector: 'app-loaded',
  templateUrl: './loaded.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex-grow: 1;
        overflow: auto;
      }

      ::ng-deep .toast-top-right {
        top: 122px;
        right: 12px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadedComponent implements OnDestroy {
  private subs = new SubSink();
  viewModel$: Observable<ViewModel>;

  constructor(
    private workSvc: WorkService,
    private router: Router,
    private webPop: WebPopService,
    private idleSvc: IdleService
  ) {
    this.viewModel$ = this.initViewModel();
    this.subs.sink = this.webPop.webTabs$
      .pipe(filter((tabs) => !!tabs && tabs.length > 0))
      .subscribe(() => this.router.navigate(['/work', 'web', '0']));
  }

  @HostListener('keydown')
  keyDown(event: KeyboardEvent) {
    this.idleSvc.agentInteraction();
  }

  @HostListener('mousedown')
  mouseDown(event: KeyboardEvent) {
    this.idleSvc.agentInteraction();
  }

  private initViewModel() {
    return merge<Partial<ViewModel>>(
      this.workSvc.scriptDisabled$.pipe(
        map((scriptDisabled) => ({ scriptDisabled }))
      ),
      this.workSvc.testMode$.pipe(map((testMode) => ({ testMode: testMode }))),
      this.webPop.webTabs$.pipe(
        map((tabs) => ({ webTitles: tabs.map((tab) => tab?.title || 'Web') }))
      ),
      this.workSvc.master$.pipe(
        map((m) => {
          let contactDetails: string = '';
          if (m) {
            contactDetails = `Campaign ${m.campaignId}`;
            if (m.recordId) {
              contactDetails = `Record ${m.recordId} - ${contactDetails}`;
            }
            if (m.first || m.last) {
              contactDetails = `${m.sal || ''} ${m.first || ''} ${
                m.last || ''
              } - ${contactDetails}`;
            }
          }
          return { contactDetails };
        })
      )
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}

interface ViewModel {
  contactDetails?: string;
  scriptDisabled?: boolean;
  testMode?: boolean;
  webTitles?: string[];
}
